function reversedArray(array) {
  return array.slice(0).reverse();
}

module.exports = reversedArray;
